module.exports = __webpack_public_path__ + "static/media/step-8-id.5cfe83a3.jpg";